import { type FC } from "react";
import { useParams } from "react-router-dom";
import { useGetWorkflow, useGetWorkflowExecution, useListWorkflowExecutionActions } from "@/queries/automation-queries";
import { ErrorMessage } from "@/components/ErrorMessage";
import { WorkflowExecutionSummary } from "@/components/automations/AutomationExecutionSummary";
import { WorkflowExecutionPerformanceChart } from "@/components/automations/AutomationExecutionPerformanceChart";

export const AutomationExecutionSummaryPage: FC = () => {
    const { workflowExecutionId } = useParams<{ workflowExecutionId: string }>();
    const { data: workflowExecution, error: workflowExecutionError } = useGetWorkflowExecution(workflowExecutionId);
    const { data: workflow } = useGetWorkflow(workflowExecution?.metadata?.workflowId);
    const { data: actions = [] } = useListWorkflowExecutionActions({
        enabled: !!workflowExecutionId,
        workflowExecutionId: workflowExecutionId || "",
    });

    return (
        <div data-testid="workflow-execution-summary" className="flex size-full flex-col gap-4 pl-3">
            <ErrorMessage error={workflowExecutionError} />
            {workflowExecution && <WorkflowExecutionSummary workflowExecution={workflowExecution} />}
            {workflowExecution && (
                <WorkflowExecutionPerformanceChart workflow={workflow} actions={actions} />
            )}
        </div>
    );
};
